const getFileNameFromUrl = (url) => {
  if (!url) return "";
  const decodedUrl = decodeURIComponent(url);
  return decodedUrl.split("/").pop();
};
export { getFileNameFromUrl };
